<template>
  <BaseTypography
    class="text-primary font-bold uppercase text-sm px-6 tracking-[.39px]"
    disable-ellipsis
  >
    <slot />
  </BaseTypography>
</template>
